import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-menu-top',
  templateUrl: './menu-top.component.html',
  styleUrls: ['./menu-top.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class MenuTopComponent {
	constructor() {
	}


	public show = false; // store state
    showMenu() { // click handler
        let bool = this.show;
        this.show = bool === false ? true : false;
	}

	toggleState($t = null) {
		if($t == 'logo') {
			this.show = false;
		}else {
			this.show = this.show === false ? true : false;
		}
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/shared/menu-top/menu-top.component.ts